module.exports = __webpack_public_path__ + "img/inhaler.1ce35b2a.png";